import PCLNAnalytics from '@pcln/analytics'

const getSplunkParams = (event, attributes) => {
  const flatData = { event }
  Object.keys(attributes).forEach((key) => {
    if (typeof attributes[key] !== 'object') {
      flatData[key] = attributes[key]
    }
  })
  return flatData
}

const clearEcommerce = () => {
  typeof window !== 'undefined' && window?.dataLayer?.push?.({ ecommerce: null })
}

const logEvent = (eventName, attributes) => {
  // window.dataLayer = window.dataLayer || []
  PCLNAnalytics.GA4Enabled = true
  // PCLNAnalytics.GAEnabled = false
  const gaParams = {
    event: eventName,
    attributes,
  }
  const splunkParams = getSplunkParams(eventName, attributes)
  attributes?.ecommerce && clearEcommerce()

  //setting "priority" (2nd) param to null
  // requestIdleCallback(() => setTimeout(() => PCLNAnalytics.logEvent(gaParams, null, splunkParams), 2000), {
  //   timeout: 10000, // 15 seconds
  // })

  const fireEventLog = setTimeout(() => {
    PCLNAnalytics.logEvent(gaParams, null, splunkParams)
    clearTimeout(fireEventLog)
  }, 2000)

  requestIdleCallback(() => fireEventLog, {
    timeout: 10000, // 15 seconds
  })
}

export { logEvent }
